import { EventType } from 'shared/enums/event-type';
import OrganisationTreeNode from 'shared/features/organisation/models/organisation-tree-node';
import { DeviceType } from 'shared/models/device-type';

import { DeviceAlert } from 'features/device/domain/models/device-alert';
import DeviceCommand from 'features/device/domain/models/device-command';
import DeviceDomipEvent from 'features/device/domain/models/device-domip-event';
import DeviceGateway from 'features/device/domain/models/device-gateway';
import DeviceMonitoringResponse from 'features/device/domain/models/device-monitoring-response';
import { DeviceStatus } from 'features/device/domain/models/device-status';
import DeviceSystem from 'features/device/domain/models/device-system';
import IntercomMapping from 'features/device/domain/models/intercom-mapping';
import { DeviceFunction } from 'features/device/models/device-function';
import { SystemType } from 'features/systems/domain/models/system';

export default interface Device {
  id?: string;
  organisationUnitId?: string;
  externalId?: string;
  deviceProximityId?: string;
  name: string;
  note?: string;
  type: DeviceType;
  displayType?: string;
  function?: DeviceFunction;
  source?: string;
  isOutdated: boolean;
  importDate?: Date;
  address?: string;
  gatewayId?: string;
  gateway?: DeviceGateway;
  organisationUnitUpstreamParentBranch?: OrganisationTreeNode[];
  commands: DeviceCommand[];
  deviceMonitoring?: DeviceMonitoringResponse;
  domipEvent?: DeviceDomipEvent;
  systemId?: string;
  system?: DeviceSystem;
  status: DeviceStatus;
  deviceAlerts?: DeviceAlert[];
  detectionLoopNumber?: number;
  hasWanderingBoundaryPassages: boolean;
  canBeMonitored: boolean;
  functionalName?: string;
  eventTypeLow?: EventType;
  eventTypeHigh?: EventType;
  intercomMappings?: IntercomMapping[];
}

export const isRoomDevice = (device?: Device) =>
  (device?.system?.type === SystemType.IS32 || device?.system?.type === SystemType.IPUnit) &&
  device?.externalId?.split('_').pop() === 'room';

export const isPairedWirelessIpUnitDevice = (systemType?: SystemType) => {
  return systemType === SystemType.IPUnit;
};
